module.exports = __webpack_public_path__ + "img/cafe.daef8788.jpg";